export enum AutoBillType {
    None = 0,
    CreditCard = 1,
    DirectDebit = 2,
}

export interface AutoBillPayload {
    accountNumber?: string;
    accountType?: string;
    bsbNumber?: string;
    creditCardExpiryMonth?: string;
    creditCardExpiryYear?: string;
    creditCardName?: string;
    creditCardNumber?: string;
    creditCardSecurityCode?: string;
    creditCardType?: string;
    enabled?: boolean;
    type: AutoBillType;
    usePaymentDetails: boolean;
}
